import { css } from '@emotion/css';
const accountStyles = {
    wrap: css`
        background: #f5f6fb;
        height: 100%;
        min-height: 70vh;
        padding: 24px 0;
    `,
    inner: css`
        display: flex;
        border-radius: 16px;
        overflow: hidden;
        height: 100%;
        /* box-shadow: 0px 2px 2px rgba(0, 0, 0, .4); */
    `,
    left: css`
        /* background: #212939; */
        padding: 0 10px 30px;
        flex: 0 0 225px;
    `,
    group: css`
        margin-bottom: 8px;
        /* border-bottom: 1px solid #595757; */
        .heading-icon {
            transition: 0.25s;
            color: #fff;
        }
        &.active {
            .heading-icon {
                transform: rotate(180deg);
            }
        }
    `,

    headingGroup: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px;
        margin: -8px -8px 0;
        cursor: pointer;
    `,
    title: css`
        padding-left: 6px;
        color: var(--agent-color);
        font-weight: 400;
    `,
    optionList: css`
        /* margin-bottom: 8px; */
        height: 0;
        overflow: hidden;
        transition: 0.25s;
        padding: 0 3px;
    `,
    optionItem: css`
        display: flex;
        align-items: center;
        padding: 4px 8px;
        cursor: pointer;
        border: 1px solid transparent;
        border-radius: 8px;
        transition: 0.25s;
        box-shadow: 0 1px 2px var(--agent-color);
        margin-bottom: 4px;
        position: relative;
        background: #ffffff;
        &:after {
            content: "";
            position: absolute;
            border: solid #231F20;
            border-width: 0 1px 1px 0;
            display: inline-block;
            padding: 3px;
            transform: rotate(-45deg) translateY(-50%);
            -webkit-transform: rotate(-45deg) translateY(-50%);
            right: 10px;
            top: 50%;
        }
        img {
            width: 25px;
            margin-right: 6px;
            &.activeIcon {
                filter: invert(1);
            }
        }
        p {
            flex: 1;
            font-size: 14px;
            color: #221041;
        }
        &.active, &:hover {
            background: linear-gradient(to bottom, #B80005, #710003);
            &:after {
                border-color: #fff;
            }
            img {
                filter: invert(1);
            }
            p {
                color: #fff;
                font-weight: 500;
            }
        }
    `,
    right: css`
        flex: 0 0 calc(100% - 245px);
        max-width: calc(100% - 245px);
        background: #fff;
        background-size: cover;
    `,
};
export default accountStyles;
